require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gruppo-di-ricerca-ilaria-giannetti.json") })
        }
      }, "path---gruppo-di-ricerca-ilaria-giannetti");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gruppo-di-ricerca-ilaria-giannetti!./.cache/json/gruppo-di-ricerca-ilaria-giannetti.json
// module id = 661
// module chunks = 231608221292675